import React from 'react';
import { TableRow } from './TableRow';
import { InflowOutflowDTO } from '../ProjectedCashFlowReport.meta';

interface Props {
  rows: InflowOutflowDTO[];
}

export const TableBody = ({ rows }: Props) => {
  return (
    <>
      {rows.map(({ Name, Totals }) => (
        <TableRow key={Name} title={Name} cells={Totals} />
      ))}
    </>
  );
};
